// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BRCIw","content":"styles_content__5skTE"};